export const CLIPPED_ANGLE = 14;
